import { Component, Input, OnInit } from '@angular/core';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { ActivatedRoute, Router } from '@angular/router';
import { TourService } from 'app/main/services/tour.service';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-tour',
	templateUrl: './tour.component.html',
	styleUrls: ['./tour.component.scss']
})
export class TourPageComponent implements OnInit{

	@Input() preview: any;

	isToggleActive: any = {
		'info_utili': true, 
		'descrizione': false, 
		'incl_escl': false,
		'note': false,
		'destinazioni': false,
		'prima_di_partire': false
	};

	constructor(
		public recordService: RecordService, 
		public datasetACS: DatasetActionContainerService,
		public tourService: TourService,
		public appService: AppService,
		protected activatedRoute: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService) {
	}

	ngOnInit(): void {
		this.tourService.responseData.next(this.preview);
		this.onLoaded();
	}

	protected onLoaded(): void{
		// load language codes
		this.translate
		.use(this.tourService.lang)
		.subscribe(() => {
			this.appService.setLanguages(this.tourService.active_language_codes);
			this.appService.loadingLanguages.next(false);
		});
	}

	scrollToBooking($element): void{
		$element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
	}

	geoPosition(destination: any): any{
		const valueGeoPos = JSON.parse(destination.properties.geo_position.value);
		if (valueGeoPos && valueGeoPos.lat && valueGeoPos.lng){
			const pos = valueGeoPos.lat + ',' + valueGeoPos.lng;
			return 'https://maps.google.com/?q=' + pos + '&ll=' + pos + '&z=' + valueGeoPos.zoom;
		}
		return 'https://maps.google.com/?q=' + destination.description;
	}

	toggleContent(content: string): void{
		if (this.isToggleActive[content]){
			this.isToggleActive[content] = false;
		} else {
			this.isToggleActive[content] = true;
		}
	}
}
